<template>
  <v-card elevation="1">
    <v-card-title>
      <v-row justify="space-between">
        <v-col cols="12" sm="6" md="4" lg="3">
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            :label="$t('label.search')"
            dense
            outlined>
          </v-text-field>
        </v-col>
      </v-row>
    </v-card-title>
    <v-card-text>
      <v-data-table
        :headers="headers"
        :items="auctions"
        :search="search"
        :loading="isLoading"
        :options="options">
        <template v-slot:item.title="{ item }">
          <span :title="item.title">{{ getTitleFixed(item.title) }}</span>
        </template>
        <template v-slot:item.statusId="{ item }">
          <span>{{ $t(`auctionStatus.${item.statusId}`) }}</span>
        </template>
        <template v-slot:item.currentPrice="{ item }">
          ${{ item.basePrice }} {{ item.currencyType.code }}
        </template>
        <template v-slot:item.options="{ item }">
          <v-btn :title="$t('label.evaluation')" icon v-if="isEvaluated(item)" @click.stop="selectAuction(item, 'evaluation')">
            <v-icon color="primary">mdi-star-check</v-icon>
          </v-btn>
          <v-btn :title="$t('label.details')" icon @click.stop="selectAuction(item, 'detail')">
            <v-icon color="primary">mdi-file-document</v-icon>
          </v-btn>
          <v-btn :title="$t('label.messages')" icon @click.stop="selectAuction(item, 'chat')">
            <v-icon color="primary">mdi-message</v-icon>
          </v-btn>
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>

<script>
import { loading, showMessage } from '../../../mixins'
import status from '../../../core/Auctions/status'
import { extractDateTime, formatDateTime } from '../../../core/sharedFunctions'

export default {
  name: 'AuctionsList',
  mixins: [loading, showMessage],
  data: () => ({
    auctions: [],
    search: '',
    options: {
      sortBy: ['id'],
      sortDesc: [true],
      itemsPerPage: 10
    }
  }),
  computed: {
    headers () {
      const headers = [
        { text: '#', value: 'id', align: 'center', sortable: true, filterable: true },
        { text: this.$t('label.title'), value: 'title', align: 'center', sortable: true, filterable: true },
        { text: this.$t('label.status'), value: 'statusId', align: 'center', sortable: true, filterable: true },
        { text: `${this.$t('label.price')}`, value: 'currentPrice', align: 'center', sortable: true, filterable: true },
        { text: this.$t('label.options'), value: 'options', align: 'center', sortable: false, filterable: false }
      ]
      return headers
    }
  },
  methods: {
    getAuctions () {
      this.changeLoadingStatus(true)
      this.$proxy.get(`api/auctions?statusIds=${status.EVALUATED},${status.OPEN}&whereIamWinner=true`)
        .then((r) => {
          r.data = r.data.filter(a => a.statusId !== status.OPEN)
          this.auctions = r.data
          this.auctions.map((a) => {
            // Set finish On date
            const date = new Date(extractDateTime(a.startDateTime))
            date.setTime(date.getTime() + (a.hoursToExpire * 60 * 60 * 1000))
            a.finishOn = formatDateTime(date)
          })
        })
        .catch((e) => {
          this.showHttpErrorMessage(e)
        })
        .finally(() => {
          this.changeLoadingStatus(false)
        })
    },
    selectAuction (item, action) {
      this.$emit('itemSelected', item, action)
    },
    isEvaluated (item) {
      if (item.statusId === status.EVALUATED) {
        return true
      }
      return false
    },
    getTitleFixed (title) {
      const length = 30
      if (title.length > length) {
        return `${title.substring(0, length)}...`
      }
      return title
    }
  },
  mounted () {
    this.getAuctions()
  }
}
</script>

<style scoped>
  .clickable {
    cursor: pointer;
  }
</style>
